import { FC } from 'react'
import { Button, FlexboxGrid } from 'rsuite'

import AddIcon from '../../Icons/BuyerPortal/AddIcon'
import useIsOnMobile from '../../../services/useIsOnMobile'
import { DARK_GREY_COLOR, ScreenSize } from '../../../utils/constants'

import styles from '../../../styles/BuyerPortal/AddNewEntryButton.module.less'

interface AddNewEntryButtonProps {
  buttonText: string
  openModal: () => void
  isLoading?: boolean
  testId?: string
}

const AddNewEntryButton: FC<AddNewEntryButtonProps> = (
  {
    buttonText,
    openModal,
    isLoading = false,
    testId = 'add-new-entry-button',
  },
) => {
  const isOnMobile = useIsOnMobile(ScreenSize.md)

  return (
    !isOnMobile ? (
      <FlexboxGrid align="middle">
        <Button
          appearance="subtle"
          className={`text-color-primary ${styles['new-entry-button']}`}
          loading={isLoading}
          onClick={openModal}
          data-testid={testId}
        >
          <AddIcon />
          <b className="margin-left-spacer-half">{buttonText}</b>
        </Button>
      </FlexboxGrid>
    )
      : (
        <Button
          appearance="ghost"
          className={`${styles['new-entry-button']}`}
          loading={isLoading}
          onClick={openModal}
          block
          data-testid={testId}
        >
          <FlexboxGrid
            align="middle"
            justify="center"
          >
            <AddIcon
              size="20"
              fill={DARK_GREY_COLOR}
            />
            <b className="margin-left-spacer h5 margin-bottom-zero-important">{buttonText}</b>
          </FlexboxGrid>
        </Button>
      )
  )
}

export default AddNewEntryButton
